import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import API from 'api';
import HeaderTypography from 'components/Common/HeaderTypography';
import { useHistory } from 'react-router-dom';
import Market, { Statuses as FanPageStatuses } from 'models/business/Market';
import MarketCard from './MarketCard';
import NewMarketCard from './NewMarketCard';
import Styles from './index.module.css';

export default function MarketDashboard({ markets, onChangeMarkets }) {
  const history = useHistory();
  // const [markets, setMarkets] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);

  const newMarktetOnClick = () => {
    history.push({
      pathname: '/MarketSetting',
      state: new Market(),
    });
  };

  const updateOnClick = (market) => {
    history.push({
      pathname: '/MarketSetting',
      state: market,
    });
  };

  const deleteOnClick = async (market) => {
    const result = await API.mall.postDeleteMall(market.id);
    if (result.error) {
      alert(result.error.errorMsg);
      return;
    }
    onChangeMarkets();
  };

  const confirmFanPageOnclick = async (market) => {
    const newMarket = market.clone();
    newMarket.fanPageStatus = FanPageStatuses.Confirmed;
    const result = await API.mall.postUpdateMall(newMarket.toJSON());
    if (result.error) {
      alert(result.error.errorMsg);
      return;
    }
    onChangeMarkets();
  };

  const renderMarkets = useMemo(() => (
    markets.map((market) => (
      <div
        className={Styles.cardItem}
        key={market.id}
      >
        <MarketCard
          market={market}
          updateOnClick={updateOnClick}
          deleteOnClick={deleteOnClick}
          confirmFanPageOnclick={() => confirmFanPageOnclick(market)}
        />
      </div>
    ))
  ), [markets]);

  return (
    <div
      className={Styles.MarketDashboardContainer}
    >
      <div className={Styles.cardItem}>
        <div
          style={{
            alignSelf: 'left',
            paddingTop: '11px',
            paddingBottom: '7px',
          }}
        >
          <HeaderTypography>
            我的賣場
          </HeaderTypography>
        </div>
      </div>

      {renderMarkets}
      <div className={Styles.cardItem}>
        <NewMarketCard onClick={newMarktetOnClick} />
      </div>
    </div>
  );
}

MarketDashboard.propTypes = {
  markets: PropTypes.arrayOf(PropTypes.instanceOf(Market)),
  onChangeMarkets: PropTypes.func,
};

MarketDashboard.defaultProps = {
  markets: [],
  onChangeMarkets: () => {},
};
